module.exports = __webpack_public_path__ + "img/logo-light.85f4bde9.svg";